import React, { useState } from "react";
import clsx from "clsx";
import moment from "moment-timezone";
import { TableSortLabel } from "@material-ui/core";
import { useStyles } from "./ValetInventoryHistoryTable.styles";
import "../../ResponsiveTable/_responsive.table.css";
import useCurrentFacilityTimezone from "../../../hooks/useCurrentFacilityTimezone";
import ValetInventoryDetailDrawer from "../ValetInventoryDetailDrawer/ValetInventoryDetailDrawer";
import { SORT_DIRECTION, SORT_BY, DEFAULT_SORT_DIRECTION } from "./constants";

const ValetInventoryHistoryTable = ({
  results = [],
  sortBy,
  sortDirection,
  onSortRequest,
}) => {
  const classes = useStyles();
  const { timeZone } = useCurrentFacilityTimezone();
  const [selectedCredential, setSelectedCredential] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const columns = [
    { id: SORT_BY.TicketNumber, label: "Ticket Number", sortable: true },
    { id: SORT_BY.Customer, label: "Customer", sortable: true },
    { id: SORT_BY.GuestType, label: "Guest Type", sortable: true },
    { id: SORT_BY.Rate, label: "Rate", sortable: true, hideInMobile: true },
    { id: SORT_BY.EntranceTime, label: "Entrance Time", sortable: true, hideInMobile: true },
    { id: SORT_BY.Make, label: "Make", sortable: true, hideInMobile: true },
    { id: SORT_BY.Model, label: "Model", sortable: true, hideInMobile: true },
    { id: SORT_BY.Status, label: "Status", sortable: true, hideInMobile: true },
  ];

  const handleSortClick = (columnId) => {
    if (onSortRequest) {
      onSortRequest(columnId);
    }
  };

  const getSortDirection = (columnId) => {
    const isActiveColumn = sortBy === columnId;
    if (!isActiveColumn) {
      return DEFAULT_SORT_DIRECTION === SORT_DIRECTION.ASCENDING ? "asc" : "desc";
    }
    return sortDirection === SORT_DIRECTION.ASCENDING ? "asc" : "desc";
  };

  const onRowClick = (result) => {
    setSelectedCredential(result);
    setDrawerOpen(true);
  };

  const onDrawerClose = () => {
    setSelectedCredential(null);
    setDrawerOpen(false);
  };

  return (
    <>
      <table className={clsx(classes.resultTable, "a1-responsive")}>
          <thead className={clsx(classes.thHeader)}>
            <tr>
              {columns.map((column) => (
                <th
                  key={column.id}
                  className={clsx(
                    classes.resultHeader,
                    column.hideInMobile && "hide-in-mobile",
                    column.sortable && classes.sortableHeader
                  )}
                >
                  {column.sortable ? (
                    <TableSortLabel
                      active={sortBy === column.id}
                      direction={getSortDirection(column.id)}
                      onClick={() => handleSortClick(column.id)}
                      className={classes.sortLabel}
                    >
                      {column.label}
                    </TableSortLabel>
                  ) : (
                    column.label
                  )}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {results.map((result, index) => (
              <tr
                key={result.credentialId}
                className={clsx(["clickable-row"])}
                onClick={() => onRowClick(result)}
                data-selected={
                  result.contextID === selectedCredential?.contextID
                }
                data-testid="clickable-row"
              >
                <td
                  data-column="Ticket Number"
                  className={clsx([classes.column])}
                >
                  {result.ticketNumber}
                </td>
                <td data-column="Customer" className={clsx([classes.column])}>
                  {result.customerName}
                </td>
                <td data-column="Guest Type" className={clsx([classes.column])}>
                  {result.guestType}
                </td>
                <td
                  data-column="Rate"
                  className={clsx([classes.column, "hide-in-mobile"])}
                >
                  {result.rate}
                </td>
                <td
                  data-column="Entrance Time"
                  className={clsx([classes.column, "hide-in-mobile"])}
                >
                  <span>
                    {moment
                      .utc(result.entranceTime)
                      .tz(timeZone)
                      .format("MM/DD/YYYY h:mm A")}
                  </span>
                </td>
                <td
                  data-column="Make"
                  className={clsx([classes.column, "hide-in-mobile"])}
                >
                  {result.make}
                </td>
                <td
                  data-column="Model"
                  className={clsx([classes.column, "hide-in-mobile"])}
                >
                  {result.model}
                </td>
                <td
                  data-column="Status"
                  className={clsx([classes.column, "hide-in-mobile"])}
                >
                  {result.statusName}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      <ValetInventoryDetailDrawer
        credential={selectedCredential}
        open={drawerOpen}
        onClose={(success) => onDrawerClose()}
      />
    </>
  );
};

export default ValetInventoryHistoryTable;
